// @ts-check
import React, { forwardRef } from "react"
import { OverlayPanel } from "../../../atoms/OverlayPanel.atom"
import SecondaryButton from "../../../molecules/buttons/SecondaryButton.molecule"
import PrimaryButton from "../../../molecules/buttons/PrimaryButton.molecule"

/**
 * @type {React.ForwardRefExoticComponent<
 *   import("./TableFilterOverlay.component.types").TableFilterOverlayProps &
 *   React.RefAttributes<any>
 * >}
 */
export const TableFilterOverlay = forwardRef((props, ref) => {
  const { renderFilterElement, onApply, onClear } = props

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <OverlayPanel ref={ref} className="table__filter-overlay">
        <div className="table__filter-element">{renderFilterElement()}</div>
        <div className="table__filter-button-bar">
          <SecondaryButton
            className="table__filter-button"
            label="Limpiar"
            onClick={onClear}
          />
          <PrimaryButton
            className="table__filter-button"
            label="Aplicar"
            onClick={onApply}
          />
        </div>
      </OverlayPanel>
    </div>
  )
})
